<div class="container">
    <fieldset>
        <div class="row">
            <div class="col-24" *ngIf="!isFormValid">
                <div class="alert danger">
                    <p><em>Error Message:</em></p>
                    <ul>
                        <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Login Id'" [text]="userProfileModel.UserProfileName"
                        [disabled]="'true'" [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ConfirmProfileSetPassword [password]="passwordResetModel.newPassword"
                        [passwordConfirmation]="passwordResetModel.confirmPassword"
                        (onPasswordChange)="passwordResetModel.newPassword = $event"
                        (onPasswordConfirmationChange)="passwordResetModel.confirmPassword = $event">
                    </ConfirmProfileSetPassword>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="resetPassword()">Reset</button>
                <button class="button cancel" (click)="cancelData()">Back</button>
            </div>
        </div>
        <div class="row">
            <div class="col-24" *ngIf="showSuccessMsg">
                <div class="alert success">
                    {{errorConfMsg}}
                </div>
            </div>
        </div>
    </fieldset>
</div>